import { Button, CheckIcon, CloseCircleIcon, ErrorCircleIcon, useClickOutside } from '@hermes/web-components'
import React, { Dispatch, SetStateAction, useRef, useState } from 'react'

import { TextInput } from './TextField.styles'

export interface InputProps {
  value: string
  hiddenLabel?: boolean
  onChange: Dispatch<SetStateAction<string>>
  label: string
  startAdornment?: React.ReactNode
  placeholder?: string
  required?: boolean
  autoComplete?: 'email' | 'new-password' | 'current-password' | 'tel' | 'url' | 'number' | 'off'
  autoCorrect?: string
  type?: 'email' | 'password' | 'tel' | 'url' | 'number' | 'text' | 'search'
  validation?: (
    value: string,
    setInputError: Dispatch<SetStateAction<boolean>>,
    setInputSuccess: Dispatch<SetStateAction<boolean>>
  ) => void
  onClick?: () => void
}

const Input = ({
  value,
  hiddenLabel = false,
  onChange,
  label,
  type = 'text',
  required = false,
  autoComplete = 'off',
  autoCorrect = 'off',
  validation = () => null,
  placeholder = '',
  onClick = () => null,
  startAdornment,
  ...rest
}: InputProps) => {
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const inputRef = useRef<HTMLDivElement>(null)

  const Adornments = () => {
    if (value.length && !success)
      return (
        <Button variant="ghost">
          <CloseCircleIcon onClick={() => onChange('')} width="20px" />
        </Button>
      )
    if (error) return <ErrorCircleIcon className="input-error-icon" width="23px" height="23px" />
    if (success) return <CheckIcon className="input-check-icon" width="23px" />
    return ''
  }

  useClickOutside(inputRef, () => validation(value, setError, setSuccess))

  return (
    <TextInput
      sx={{ display: 'flex' }}
      type={type}
      autoComplete={autoComplete}
      autoCorrect={autoCorrect}
      hiddenLabel={hiddenLabel}
      label={label}
      value={value}
      color={error ? 'error' : 'success'}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      placeholder={placeholder}
      onClick={onClick}
      onFocus={() => {
        setError(false)
        setSuccess(false)
      }}
      InputProps={{
        ref: inputRef,
        startAdornment,
        endAdornment: Adornments()
      }}
      {...rest}
    />
  )
}

export default Input
